import React from 'react'
import './newconnector.css'
import ConnectorType from './AddConnector/ConnectorType'

const NewConnector = () => <ConnectorType />

export default NewConnector
